function getApiBase() {
  // Allow explicit override via env var
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  const hostname = window.location.hostname;

  // Local development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8000/api';
  }

  // Production: portal.<domain> calls api.<domain>, over HTTPS.
  //
  // Derived rather than hardcoded per brand. The previous version matched only
  // 'carsmartai.com', so after the AutoLota rename portal.autolota.com fell through to
  // the IP fallback below and resolved to http://portal.autolota.com:8000/api — plain
  // HTTP on an HTTPS page (blocked as mixed content), on port 8000, bypassing nginx
  // entirely. The portal was therefore broken on the new domain and working only on the
  // old one. Deriving api.<domain> from portal.<domain> means the next rename needs no
  // frontend change at all.
  const portalMatch = hostname.match(/^portal\.(.+)$/i);
  if (portalMatch) {
    return `https://api.${portalMatch[1]}/api`;
  }

  // Any other known production host (bare domain, www, legacy) — keep both brands
  // resolving explicitly rather than guessing.
  if (hostname.includes('autolota.com')) {
    return 'https://api.autolota.com/api';
  }
  if (hostname.includes('carsmartai.com')) {
    return 'https://api.carsmartai.com/api';
  }

  // Fallback: IP-based access (transition period)
  return `http://${hostname}:8000/api`;
}

export const API_BASE = getApiBase();
